import React from "react";
import WorshipArticleLayout from "./WorshipArticleLayout";
import {SeoHelper} from "../../components/helpers/SeoHelper";

const WorshipPlanningUsingTheLectionary = () => {
    return (
        <WorshipArticleLayout
            title="Worship Planning using the Lectionary"
            subtitle="Discover how the Church’s Lectionary can guide worship planning that is rooted in Scripture and shared across the wider Church."
            secondaryCta={{
                title: "New to lectionary-based worship?",
                text: "You may find it helpful to explore how Scripture shapes worship more broadly before planning with the lectionary.",
                label: "Worship Songs by Bible Passage",
                href: "/worship/worship-songs-by-bible-passage"
            }}
            primaryCta={{
                title: "Plan Using the Lectionary",
                label: "View Lectionary Readings",
                href: "/lectionary/choose-lectionary"
            }}
        >
            <SeoHelper
                uri = "/worship/worship-planning-using-the-lectionary"
                title = "Worship Planning using the Lectionary"
                description="Discover how the Church’s Lectionary can guide worship planning that is rooted in Scripture and shared across the wider Church."
            />

            <p className="article-intro">
                For many churches, the lectionary provides a shared rhythm of Scripture that shapes worship across the Christian year. It offers both structure and freedom.
            </p>

            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3">What Is the Lectionary?</h2>
            <p>
                A lectionary is a cycle of Scripture readings arranged around the life of Christ and the seasons of the Church year. It helps congregations dwell in the breadth of Scripture over time.
            </p>

            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3">Why Plan Worship with the Lectionary?</h2>
            <p>
                Using the lectionary ensures that worship is not shaped only by personal preference or familiarity, but by the wider witness of Scripture.
            </p>

            <ul style={{marginTop: 0 + "cm", fontWeight: 300}} type="square" className="MsoNormal"><li>Connects worship to the Church calendar</li><li>Encourages engagement with the whole Bible</li><li>Unites congregations around shared readings</li></ul>

            <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">From Readings to Worship</h3>
            <p>
                Lectionary readings often suggest themes that can shape prayers, songs, and the overall movement of worship. Planning with these readings helps worship feel both rooted and connected.
            </p>

            <p>
                The Worship Bible helps you explore lectionary readings and discover worship songs that reflect their themes, supporting worship that is biblically grounded and pastorally sensitive.
            </p>

        </WorshipArticleLayout>
    );
};

export default WorshipPlanningUsingTheLectionary;